import CategoriaFormularioService from 'src/modules/categoriaFormulario/categoriaFormularioService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'CATEGORIAFORMULARIO_FORM';

const categoriaFormularioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormularioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await CategoriaFormularioService.find(id);
      }

      dispatch({
        type: categoriaFormularioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormularioFormActions.INIT_ERROR,
      });

      getHistory().push('/categoria-formulario');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormularioFormActions.CREATE_STARTED,
      });

      await CategoriaFormularioService.create(values);

      dispatch({
        type: categoriaFormularioFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.categoriaFormulario.create.success'),
      );

      getHistory().push('/categoria-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormularioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: categoriaFormularioFormActions.UPDATE_STARTED,
      });

      await CategoriaFormularioService.update(id, values);

      dispatch({
        type: categoriaFormularioFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.categoriaFormulario.update.success'),
      );

      getHistory().push('/categoria-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaFormularioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default categoriaFormularioFormActions;
